import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/usuario?${serialize(filtros)}`, { tela: 'acesso_usuario' })
}

export async function get (id) {
  return httpAuth.get(`/usuario/${id}`, { tela: 'acesso_usuario' })
}

export async function add (dados) {
  return httpAuth.post(`/usuario`, dados, { funcionalidade: 'acesso_usuario_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/usuario/${id}`, dados, { funcionalidade: 'acesso_usuario_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/usuario/${id}`, { funcionalidade: 'acesso_usuario_excluir' })
}
